import { createOrUpdateUserAddressDetailsGraphQlMutation } from '../createOrUpdateUserAddressDetails';
import { createOrUpdateUserBasicProfilesDetailsGraphQlMutation } from '../createOrUpdateUserBasicProfilesDetails';
import { createOrUpdateUserCurrentProfessionalDetailsGraphQlMutation } from '../createOrUpdateUserCurrentProfessionalDetails';
import { createOrUpdateUserDegreeDetailGraphQlMutation } from '../createOrUpdateUserDegreeDetail';
import { createOrUpdateUserGuardianDetailsGraphQlMutation } from '../createOrUpdateUserGuardianDetails';
import { createOrUpdateUserIntermediateDetailsGraphQlMutation } from '../createOrUpdateUserIntermediateDetails';
import { createOrUpdateUserSSCDetailsGraphQlMutation } from '../createOrUpdateUserSSCDetails';

export const getNiatApplicationDynamicMutation = (
  mutationFunctionName: string,
  requestObjectForMutation: Record<string, any>
): {
  mutation: string;
  data: Record<string, any>;
} => {
  const mutations: Record<
    string,
    { mutation: string; type: string; variableName: string }
  > = {
    UserProfile: {
      ...createOrUpdateUserBasicProfilesDetailsGraphQlMutation(false),
      variableName: 'user_basic_details_input'
    },
    UserGuardianDetails: {
      ...createOrUpdateUserGuardianDetailsGraphQlMutation(false),
      variableName: 'user_guardian_details_input'
    },
    UserSSCDetails: {
      ...createOrUpdateUserSSCDetailsGraphQlMutation(false),
      variableName: 'user_ssc_details_input'
    },
    UserIntermediateDetails: {
      ...createOrUpdateUserIntermediateDetailsGraphQlMutation(false),
      variableName: 'user_intermediate_details_input'
    },
    UserDegreeDetails: {
      ...createOrUpdateUserDegreeDetailGraphQlMutation(false),
      variableName: 'user_degree_details_input'
    },
    UserAddressDetails: {
      ...createOrUpdateUserAddressDetailsGraphQlMutation(false),
      variableName: 'user_address_details_input'
    },
    UserCurrentProfessionalDetails: {
      ...createOrUpdateUserCurrentProfessionalDetailsGraphQlMutation(false),
      variableName: 'user_professional_details_input'
    }
  };

  let mutationFields = '';
  let variableDefinitions = '';
  const variables: Record<string, any> = {};

  Object.entries(requestObjectForMutation).forEach(([key, value]) => {
    if (mutations[key]) {
      const { mutation, type, variableName } = mutations[key];

      variableDefinitions += `$${variableName}: ${type}, `;
      mutationFields += `${mutation}
      `;
      variables[variableName] = value;
      if (key === 'UserAddressDetails') {
        variables[variableName] = {
          ...value,
          address_type: 'PERMANENT'
        };
        if (
          variables[variableName]?.state_name &&
          !variables[variableName]?.district_name
        ) {
          variables[variableName].district_name = '';
          variables[variableName].district_id = '';
        }
      }

      if (key === 'UserDegreeDetails') {
        variables[variableName].type = 'BACHELORS';
      }
    }
  });

  if (!mutationFields) {
    return {
      mutation: '',
      data: {}
    };
  }

  const finalMutation = `
    mutation ${mutationFunctionName}(${variableDefinitions.trim().replace(/,$/, '')}) {
      ${mutationFields.trim()}
    }
  `;

  return {
    mutation: finalMutation,
    data: variables
  };
};
